import { z } from "zod";
/**
 * A composed agent (agent-library plan): what it reads and how it counts,
 * in fixed parts only. The source registry (apps/api/src/composed/sources.ts)
 * decides which keys exist; this schema decides the shape.
 */
export const WINDOWS = ["last_7_days", "last_week", "last_30_days", "last_month", "month_to_date", "snapshot"];
export const SCHEDULES = ["on_request", "daily_0700", "weekly_mon_0800", "monthly_1st_0800"];
export const OUTPUT_FORMATS = ["pptx", "xlsx", "docx", "pdf"];
/** What an agent delivers when it says nothing: slides, in the thread. */
export const DEFAULT_OUTPUT = { formats: ["pptx"], email: false };
export const AGGS = ["count", "sum", "avg", "min", "max", "share_true"];
const Key = z.string().regex(/^[a-z][a-z0-9_]{1,40}$/);
export const AgentSpecSchema = z
    .object({
    source: Key,
    measures: z.array(z.object({ key: Key, agg: z.enum(AGGS) }).strict()).min(1).max(4),
    group_by: Key.optional(),
    filters: z.array(z.object({ dim: Key, in: z.array(z.string().min(1).max(60)).min(1).max(12) }).strict()).max(4).default([]),
    window: z.enum(WINDOWS),
    compare: z.enum(["previous_window"]).optional(),
    threshold: z.object({ measure: Key, op: z.enum([">", "<"]), value: z.number().finite() }).strict().optional(),
    top_n: z.number().int().min(1).max(20).optional(),
    schedule: z.enum(SCHEDULES).default("on_request"),
    output: z.object({
        formats: z.array(z.enum(OUTPUT_FORMATS)).min(1).max(2),
        // Unsaid is no: email only when the person asked for it.
        email: z.boolean().default(false),
    }).strict().default(DEFAULT_OUTPUT),
})
    .strict()
    .refine((s) => !s.threshold || s.measures.some((m) => m.key === s.threshold.measure), {
    message: "The threshold must be on one of the spec's measures.",
    path: ["threshold", "measure"],
});
